module.exports = __webpack_public_path__ + "assets/img/3.1af5df10.png";